module.exports = __webpack_public_path__ + "images/icono-2--5-recomendaciones.jpg";